import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=2d209487&scoped=true&"
import script from "./ChangePass.vue?vue&type=script&lang=js&"
export * from "./ChangePass.vue?vue&type=script&lang=js&"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=2d209487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d209487",
  null
  
)

export default component.exports